<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <history-table :title="$t('history')"></history-table>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import HistoryTable from './Tables/HistoryTable'
  export default {
    name: 'history',
    components: {
      HistoryTable
    }
  }
</script>
<style></style>
